import React from "react";
import PropTypes from "prop-types";
import { toSlice } from "data/slices";
import TwoPaneMultiSelect, { contentBlocksType } from "lib/common/twopanemultiselect/TwoPaneMultiSelect";
import TwoPaneMultiSelectStore
    from "lib/common/twopanemultiselect/data/TwoPaneMultiSelectStore";
import TwoPaneMultiSelectActions
    from "lib/common/twopanemultiselect/data/TwoPaneMultiSelectActions";
import useFluxStore from "@armus/use-flux-store";

function buildTree(groups, selection) {
    return toSlice(groups, "key", g => {
        const hasGroup = selection.hasOwnProperty(g.key);
        return {
            ...g,
            items: toSlice(g.items, "key", it => ({
                ...it,
                selected: hasGroup && selection[g.key].indexOf(it.key) >= 0,
            })),
        };
    });
}

function splitTree(tree, selected) {
    return tree.keys
        .map(gk => {
            const g = tree.byKey[gk];
            return {
                key: g.key,
                name: g.name,
                items: g.items.keys
                    .map(ik => g.items.byKey[ik])
                    .filter(it => selected ? it.selected : !it.selected)
                    .map(it => ({
                        key: it.key,
                        name: it.name,
                    })),
            };
        })
        .filter(g => g.items.length > 0);
}

const TwoPaneMultiSelectContainer = (props) => {
    const state = useFluxStore(() => {
        const groups = TwoPaneMultiSelectStore.getGroups();
        const selection = TwoPaneMultiSelectStore.getSelection();
        const tree = buildTree(groups, selection);
        return {
            triggerSave: () =>
                props.triggerSave(selection),
            scrollState: TwoPaneMultiSelectStore.getScrollState(),
            unselectedTree: splitTree(tree, false),
            selectedTree: splitTree(tree, true),
            onToggleItem: TwoPaneMultiSelectActions.toggleItem,
            onHandleScroll: TwoPaneMultiSelectActions.handleScroll,
            onUpdatePositions: TwoPaneMultiSelectActions.updatePositions,
        };
    }, [
        TwoPaneMultiSelectStore,
    ], [
        props.triggerSave,
    ]);
    return <TwoPaneMultiSelect {...props} {...state} />;
};

TwoPaneMultiSelectContainer.propTypes = {
    triggerClose: PropTypes.func.isRequired,
    triggerSave: PropTypes.func.isRequired,
    contentBlocks: contentBlocksType,
};

export default TwoPaneMultiSelectContainer;



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/TwoPaneMultiSelectContainer.js